import {PiWarningCircle} from 'react-icons/pi';

import styled from 'styled-components';

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
  focused?: boolean;
}

interface InputProps {
  error?: boolean;
}

export const Wrapper = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
`;

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 6px;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
`;

export const ContainerLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(0, 0, 0, 0.6);
`;

export const Label = styled.label<InputProps>`
  font-weight: 600;
  color: ${(props) =>
    props.error ? props.theme.colors.error : props.theme.colors.text};
`;

export const Input = styled.input<InputProps>`
  border: 1px solid
    ${(props) =>
      props.error ? props.theme.colors.error : props.theme.colors.inputBorder};
  border-radius: 4px;
  padding: 10px;
  color: ${(props) => props.theme.colors.text};
  font-weight: 600;
  background-color: transparent;
`;
